const transformFileToImageObject = file => ({
  path: file.data.relativePath,
  width: file.file.width,
  height: file.file.height,
});

export default transformFileToImageObject;
